import {lazy, Suspense, useContext, useState} from 'react'

import Context from '@s-ui/react-context'

import InputAddonPlate from '.././components/InputAddonPlate/index.js'
import {BASE_CLASS_NAME} from '../config.js'

const NotificationPlateNotFound = lazy(() =>
  import(/* webpackChunkName: "NotificationPlateNotFound" */ '@adv-mt/mt-notifications-plate-not-found')
)

export const useFormConfiguration = () => {
  const {domain, i18n} = useContext(Context)
  const [formConfiguration, setFormConfiguration] = useState()

  const {
    formFieldIds,
    formSellerPlateConfig: {fields: formFields, initFields},
    numericFieldsToBeFormatted
  } = domain.get('config').get('form')

  const {kilometersId, notification, plate} = formFieldIds

  const fields = formFields
  const initialFields = initFields

  if (!formConfiguration) {
    setFormConfiguration(() => {
      for (const field of fields) {
        const {hint, label, help, constraints, datalist} = field
        if (hint) field.hint = i18n.t(hint, 1)
        if (label) field.label = i18n.t(label, 1)
        if (help) field.help = i18n.t(help, 1)
        if (constraints) {
          constraints.forEach(constraint => {
            if (constraint.message) constraint.message = i18n.t(constraint.message, 1)
          })
        }
        if (datalist) {
          datalist.forEach(datalistItem => {
            datalistItem.text = i18n.t(datalistItem.text, 1)
          })
        }
      }

      return {
        form: {
          id: 'cochesnet-mt-form-seller-plate',
          type: 'group',
          label: '',
          fields: [
            {
              id: 'cochesnet-mt-form-seller-plate-fieldset',
              type: 'fieldset',
              display: 'block',
              hidden: false,
              fields
            }
          ]
        }
      }
    })
  }

  const SUIComponentsConfig = ({handleOnSkip, isSubmitError}) => {
    return ({id, innerProps}) => {
      const autoHideHelpText = Boolean(innerProps?.errorText)
      const props = {
        [plate]: {autoHideHelpText, leftAddon: <InputAddonPlate />, size: 'l'},
        [notification]: isSubmitError ? (
          <Suspense fallback={<></>}>
            <div className={`${BASE_CLASS_NAME}-formNotification`}>
              <NotificationPlateNotFound onClick={handleOnSkip} />
            </div>
          </Suspense>
        ) : null,
        [kilometersId]: {autoComplete: 'off', autoHideHelpText, size: 'l'}
      }
      return props[id]
    }
  }

  return {
    formConfiguration,
    formFieldIds,
    initFields: initialFields,
    numericFieldsToBeFormatted,
    SUIComponentsConfig
  }
}
